module.exports = __webpack_public_path__ + "static/japan05-f011e74cb6e01fb5c8a68e39c6e7dc69.jpg";